import { useQuery } from '@tanstack/react-query';
import type { FeatureFlagKey } from '@jeket-cloud/types';
import { featuresApi } from '@/api/client';

/**
 * Whether a feature flag is on (#954). The BFF evaluates it (`GET
 * /api/features`) for the acting org and, given `siteId`, for that site, so a
 * flag turned on for one site shows on that site's pages only.
 *
 * False while loading and on any error. A flagged surface never flashes on,
 * and stays hidden if the flags cannot be read. Flags change by ConfigMap
 * PR, so a minute of staleness is fine. Switching org reloads the page, which
 * drops the cache.
 *
 *   const netboot = useFeature('netboot', { siteId });
 *   if (!netboot) return null;
 */
export function useFeature(flag: FeatureFlagKey, opts: { siteId?: string } = {}): boolean {
  const { data } = useQuery({
    queryKey: ['features', opts.siteId ?? null],
    queryFn: () => featuresApi.get(opts.siteId),
    staleTime: 60_000,
  });
  return data?.[flag] === true;
}
